import Header from './Header';
import {
  Box,
} from '@newulife/common'
import bgImg from 'assets/images/somaderm-waterline.jpg'

export default function Layout({ children }) {

  return (
    <Box
      sx={{
        color: 'neutralCool.dark',
        height: '100%',
        minHeight: '100vh',
        transition: 'all .2s ease',
        justifyContent: 'flex-start',
        position: 'relative',
        width: '100%',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <Header />
      {children}
    </Box>
  );
}
